module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-11aac5cd7d512f520d498c65d9a7a14c.jpg";